import React from 'react';
import { Button, Popover, Space, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import {
  colorGreen,
  colorPrimary,
  colorRed,
  icon,
  totalsContainer,
  totalsContetntLeft,
  totalsContetntRight,
} from '../styles/styles';
import { ICommit, ITogglData } from '../store/GitStatistics';
import TogglDetails from './TogglDetails';

const CommitStatTotals = ({
  commitsList,
  togglData,
}: {
  commitsList: ICommit[];
  togglData: ITogglData;
}) => {
  const addedLines =
    commitsList?.reduce((sum: any, commit: any) => sum + commit.added, 0) || 0;
  const removedLines =
    commitsList?.reduce((sum: any, commit: any) => sum + commit.removed, 0) ||
    0;

  return (
    <Space style={totalsContainer}>
      <div style={totalsContetntLeft}>
        <Typography.Text strong>
          Total commits:{' '}
          {
            <span style={{ color: '#1677ff' }}>
              {commitsList !== null ? commitsList?.length : '0'}
            </span>
          }
        </Typography.Text>
        <div>
          <img 
            src="/icon-pink.png" 
            width={20} 
            height={20} 
            style={icon} />
        </div>
        <Typography.Text strong>
          {
            <span style={colorPrimary}>
              {togglData?.total.toFixed(2) || 0} h
            </span>
          }{' '}
        </Typography.Text>
        {togglData?.projects ? (
          <Popover
            trigger="click"
            content={<TogglDetails projectList={togglData.projects} />}
            placement='bottom'
            styles={{ body: {
              padding: '8px',
              width: '200px',
            } }}
          >
            <Button type="link" style={{ display: 'flex', padding: 0 }}>
              <Typography.Text strong style={colorPrimary}>
                Details
              </Typography.Text>
            </Button>
          </Popover>
        ) : (
          <Popover 
            title={togglData?.warning} 
            placement='bottom'
          >
            <InfoCircleOutlined style={{ fontSize: '18px', ...colorPrimary }} />
          </Popover>
        )}
      </div>
      <div style={totalsContetntRight}>
        <Typography.Text strong>Lines of code:</Typography.Text>
        <Typography.Text strong style={colorGreen}>
          +{`${addedLines ?? 0}`}
        </Typography.Text>
        <Typography.Text strong>/</Typography.Text>
        <Typography.Text strong style={colorRed}>
          -{`${removedLines ?? 0}`}
        </Typography.Text>
      </div>
    </Space>
  );
};

export default CommitStatTotals;
